import { Empty } from 'antd';
import { get } from 'lodash-es';
import { useEffect } from 'react';

import { membersActions } from '@store/members/members.slice';

import { Table } from '@atom/table/table';
import { Title } from '@atom/typography/typography';
import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useLazyQuery } from '@hook/common/use-lazy-query.hook';
import { useLazyLoadMembersQuery } from '@hook/memeber/memeber.hooks';
import { useMemberRole } from '@hook/memeber/use-member-role.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { isString } from '@util/data/is-exist';

import { AccountMembersInviteModal } from './account-members-invite.modal';
import { accountMembersOptions } from './account-members.options';
import { TitleWrapper, Wrapper } from './account-members.style';

export const AccountMembers = () => {
  const { current } = useCurrentApplication();
  const { action } = useLazyQuery(
    useLazyLoadMembersQuery({ refetchOnReconnect: true, refetchOnFocus: true }),
    membersActions,
    membersActions.setData,
  );
  const { isAdmin, isOwner } = useMemberRole();

  const account = get(current, ['account', 'id']);

  const { data, isLoading } = useStoreSelector((state) => state.members);

  useEffect(() => void (isString(account) && action(account)), [account]);

  return (
    <Wrapper>
      <TitleWrapper>
        <Title level={4} mb={6} weight={400}>
          Members
        </Title>
        {(isOwner || isAdmin) && <AccountMembersInviteModal />}
      </TitleWrapper>
      <Table
        columns={accountMembersOptions}
        dataSource={Object.values(data)}
        loading={isLoading}
        locale={{ emptyText: <Empty description='No team members' image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
        pagination={false}
        rowKey='email'
      />
    </Wrapper>
  );
};
